import * as React from "react";
import { Alert } from "@grandvisionhq/iris-ui";
import { useFeatureToggles, useIntl } from "@grandvisionhq/state";
import { LocationInfo } from "../../../../components/modules/LocationInfo/components/LocationInfo.js";
const LocationInfoContainer = ({
  location,
  onEdit,
  hasMessage = true,
  hasOpeningHours
}) => {
  const { isStorePickupPhoneEnabled } = useFeatureToggles();
  const { getLabel, hasLabel } = useIntl();
  const labels = React.useMemo(
    () => ({
      message: getLabel("checkout.locationInfo.message", {
        hideLabelKey: true
      })
    }),
    [getLabel]
  );
  const isStore = React.useCallback(
    (location2) => "phone" in location2,
    []
  );
  const message = labels.message && hasMessage ? /* @__PURE__ */ React.createElement(Alert, { variant: "info", className: "alert-m-default" }, labels.message) : null;
  const title = isStore(location) ? "checkout.locationInfo.store.label" : "checkout.locationInfo.pickupPoint.label";
  return /* @__PURE__ */ React.createElement(
    LocationInfo,
    {
      isStorePickupPhoneEnabled,
      location,
      message,
      onEdit,
      hasOpeningHours,
      isStore,
      ...hasLabel(title) ? { title: getLabel(title) } : null
    }
  );
};
export {
  LocationInfoContainer
};
//# sourceMappingURL=LocationInfoContainer.js.map
